import * as _ from "lodash";
const getStateValues = (type) => {
  if (type === "new") {
    return "new";
  } else if (type === "running") {
    return "running,startrequested,stoprequested";
  } else {
    return "completed";
  }
};
const getLastActivePhase = (exp) => {
  const phases = exp.map((m) => m.Phases);
  const allPhases = _.flatten(phases);
  const activePhases = _.filter(allPhases, (p) => p.State !== "Completed" && p.State !== "New");
  const hasActivePhases = activePhases.length > 0;
  const lastActivePhase = hasActivePhases ? _.last(activePhases) : {};
  return lastActivePhase;
};
const getLastCompletedPhase = (exp) => _.chain(exp).flatMap((m) => m.Phases).filter((p) => p.State === "Completed").sortBy((p) => p.StopTime || "").last().value() || null;
const sortTemplateName = (data) => {
  return _.sortBy(data, (d) => d["IsFeatureRollout"]);
};
const sortCreatedDate = (data) => {
  return _.sortBy(data, (d) => new Date(d["Created"]));
};
const sortCompletedDate = (data) => {
  return _.sortBy(data, (d) => new Date(d["Completed"]));
};
export {
  getLastActivePhase,
  getLastCompletedPhase,
  getStateValues,
  sortCompletedDate,
  sortCreatedDate,
  sortTemplateName
};
//# sourceMappingURL=MyActivitiesUtils.js.map
